import { customerLabelForSlabStyle } from '../assets/externalSlabCatalogue';
import { getGlassDesign } from '../assets/glassCatalogue';
import { formatRalDisplay } from '../colour/productColour';
import { getProductColourForDisplay } from '../colour/productColours';
import { getHardwareProduct } from '../hardware/hardwareCatalog';
import { type DoorConfiguration, type DoorHardwareConfiguration } from '../types/doorConfiguration';

export const FRAME_LABELS: Record<DoorConfiguration['frameProfile'], string> = {
  chamfered: 'Chamfered',
  sculptured: 'Sculptured',
  'butt-joint': 'Butt Joint',
};

export function slabStyleLabel(styleId: string): string {
  return customerLabelForSlabStyle(styleId);
}

export function colourLabel(colourId: string): string {
  return getProductColourForDisplay(colourId).name;
}

export function colourDetail(colourId: string): string {
  const colour = getProductColourForDisplay(colourId);
  return `${colour.name} · ${formatRalDisplay(colour)}`;
}

export function glassLabel(glazing: DoorConfiguration['glazing']): string {
  return getGlassDesign(glazing[0]?.id)?.name ?? 'Not selected yet';
}

const ACCESSORY_LABELS: Record<string, string> = {
  knocker: 'Knocker',
  spyhole: 'Spyhole',
};

export function furnitureLabel(hardware: DoorHardwareConfiguration): string {
  const names = hardware.external.map(
    (item) => getHardwareProduct(item.id)?.name ?? ACCESSORY_LABELS[item.id]
  ).filter((name): name is string => Boolean(name));
  return names.length > 0 ? names.join(', ') : 'Not selected yet';
}
